/* Mirror Factory — scripts du thème */
(function () {
  'use strict';
  var MF = window.MF || {};
  var R = MF.routes || {};
  var T = MF.txt || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  var toastT;
  function toast(msg) {
    var el = $('#mf-toast'); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { el.hidden = true; }, 2800);
  }

  /* ---------- Pastilles de couleur ---------- */
  var FAM = { noir: '#141414', blanc: '#F7F5F0', beige: '#CFC3AE', marron: '#6E4B2E', bleu: '#2D5F93', marine: '#26386E', vert: '#5B5E3A', kaki: '#6F7446', rose: '#EBA3C6', gris: '#9EA3AA', argent: '#C9CCD1', bordeaux: '#5E2A2A', rouge: '#B3261E', or: '#D9B45A', orange: '#F27A1F', violet: '#6B4A9A', jaune: '#E8CC7A', camel: '#B98552', crème: '#ECE6D8', creme: '#ECE6D8', ivoire: '#EFE8D8', taupe: '#8B7D70', chocolat: '#4A3424' };
  function colorOf(name) {
    var map = window.MF_COLORS || {};
    if (map[name]) return map[name];
    var n = String(name || '').toLowerCase();
    for (var k in FAM) { if (n.indexOf(k) >= 0) return FAM[k]; }
    return '#A8A29A';
  }
  function paintSwatches(root) {
    $$('[data-color]', root).forEach(function (b) {
      if (b.tagName !== 'BUTTON' || b.dataset.painted) return;
      b.style.backgroundColor = colorOf(b.dataset.color); b.dataset.painted = '1';
    });
  }

  /* ---------- Panier ---------- */
  function setCount(n) { $$('[data-mf-cart-count],[data-mf-drawer-count]').forEach(function (e) { e.textContent = n; }); }
  function openDrawer() {
    var d = $('[data-mf-drawer]'); if (!d) { window.location.href = R.cart; return; }
    d.hidden = false; document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() { var d = $('[data-mf-drawer]'); if (d) d.hidden = true; document.documentElement.style.overflow = ''; }
  function refreshCart(open) {
    return fetch((R.root || '/') + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer']; if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var nb = $('[data-mf-drawer-body]', tmp), nc = $('[data-mf-drawer-count]', tmp);
        var b = $('[data-mf-drawer-body]'); if (b && nb) b.innerHTML = nb.innerHTML;
        var pb = $('[data-mf-cartpage-body]'); if (pb && nb) pb.innerHTML = nb.innerHTML;
        if (nc) setCount(nc.textContent.trim());
        if (open) openDrawer();
      });
  }
  function addToCart(items) {
    return fetch(R.cartAdd + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || T.error); return j; });
    });
  }
  function changeLine(line, qty) {
    var scope = $('[data-mf-drawer-body]'), pb = $('[data-mf-cartpage-body]');
    [scope, pb].forEach(function (e) { if (e) e.classList.add('mf-is-busy'); });
    return fetch(R.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(qty)) })
    }).then(function () { return refreshCart(false); })
      .finally(function () { [scope, pb].forEach(function (e) { if (e) e.classList.remove('mf-is-busy'); }); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var open = t.closest('[data-mf-cart-open]');
    if (open && $('[data-mf-drawer]')) { e.preventDefault(); refreshCart(true); return; }
    if (t.closest('[data-mf-drawer-close]')) { closeDrawer(); return; }
    var q = t.closest('[data-mf-qty]');
    if (q) { e.preventDefault(); changeLine(q.dataset.mfQty, q.dataset.q); return; }

    var menuOpen = t.closest('[data-mf-menu-open]');
    if (menuOpen) { var m = $('[data-mf-menu]'); if (m) { m.hidden = false; document.documentElement.style.overflow = 'hidden'; } return; }
    if (t.closest('[data-mf-menu-close]')) { var m2 = $('[data-mf-menu]'); if (m2) m2.hidden = true; document.documentElement.style.overflow = ''; return; }

    /* fermer le menu déroulant au clic sur un lien */
    var megaLink = t.closest('.mf-mega-panel a');
    if (megaLink) { var mg = megaLink.closest('.mf-mega'); if (mg) { mg.classList.add('is-closed'); if (document.activeElement) document.activeElement.blur(); } }

    /* pastilles des cartes */
    var sw = t.closest('[data-mf-swatch]');
    if (sw) {
      var card = sw.closest('[data-mf-card]');
      $$('[data-mf-swatch]', card).forEach(function (x) { x.classList.toggle('is-on', x === sw); });
      var img = $('.mf-pimg', card);
      if (img && sw.dataset.img) { img.removeAttribute('srcset'); img.src = sw.dataset.img; img.classList.remove('mf-swapA'); void img.offsetWidth; img.classList.add('mf-swapA'); }
      if (sw.dataset.url) $$('a[href]', card).forEach(function (a) { if (a.classList.contains('mf-pc-img') || a.classList.contains('mf-pc-name') || a.hasAttribute('data-mf-card-link')) a.href = sw.dataset.url; });
      var qa = $('[data-mf-quick-add]', card); if (qa && sw.dataset.variant) { qa.dataset.variant = sw.dataset.variant; qa.classList.remove('is-done'); if (qa.dataset.label) qa.textContent = qa.dataset.label; }
      return;
    }

    /* ajout rapide */
    var qadd = t.closest('[data-mf-quick-add]');
    if (qadd) {
      e.preventDefault(); if (qadd.disabled) return;
      if (!qadd.dataset.label) qadd.dataset.label = qadd.textContent;
      qadd.disabled = true;
      addToCart([{ id: Number(qadd.dataset.variant), quantity: 1 }])
        .then(function () { qadd.classList.add('is-done'); qadd.textContent = T.added + ' ✓'; return refreshCart(true); })
        .catch(function (err) { toast(err.message || T.error); })
        .finally(function () { qadd.disabled = false; });
      return;
    }

    /* valise du carnet de voyage */
    var trip = t.closest('[data-mf-trip-add]');
    if (trip) {
      var art = trip.closest('[data-mf-trip]');
      var items = $$('[data-variant]', art).map(function (a) { return { id: Number(a.dataset.variant), quantity: 1 }; });
      var need = $$('[data-needs-size]', art).map(function (a) { return a.dataset.needsSize; });
      if (!items.length && need.length) { window.location.href = $('[data-needs-size]', art).href; return; }
      trip.disabled = true;
      addToCart(items).then(function () {
        if (need.length) toast((T.needSize || 'Choisis ta taille pour : ') + need.join(', '));
        return refreshCart(true);
      }).catch(function (err) { toast(err.message || T.error); }).finally(function () { trip.disabled = false; });
      return;
    }

    /* onglets des rails */
    var tab = t.closest('[data-mf-tab]');
    if (tab) { selectTab(tab); return; }

    /* filtres du catalogue */
    if (t.closest('[data-mf-filter-toggle]')) {
      var panel = $('[data-mf-filter-panel]'), btn = $('.mf-fbtn[data-mf-filter-toggle]');
      if (panel) { panel.hidden = !panel.hidden; if (btn) btn.setAttribute('aria-expanded', String(!panel.hidden)); }
      return;
    }
    var fb = t.closest('[data-mf-brand]');
    if (fb) { fb.setAttribute('aria-pressed', fb.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); applyBrands(); return; }
    if (t.closest('[data-mf-filter-clear]')) { $$('[data-mf-brand]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); }); applyBrands(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); var m = $('[data-mf-menu]'); if (m) m.hidden = true; document.documentElement.style.overflow = ''; } });
  $$('.mf-mega').forEach(function (mg) { mg.addEventListener('mouseenter', function () { mg.classList.remove('is-closed'); }); });

  /* ---------- Recherche : abréviations courantes ---------- */
  var ALIAS = { lv: 'louis vuitton', ysl: 'saint laurent', cp: 'c.p. company', 'c.p': 'c.p. company', ap: 'audemars piguet', vca: 'van cleef', vancleef: 'van cleef',
    cg: 'canada goose', fog: 'fear of god', essentials: 'fear of god essentials', mm: 'miu miu', miumiu: 'miu miu', bv: 'bottega veneta', bottega: 'bottega veneta',
    arcteryx: "arc'teryx", 'arc teryx': "arc'teryx", jordan: 'jordan', nocta: 'nocta', airpods: 'airpods', lulu: 'lululemon', stone: 'stone island', si: 'stone island',
    hermes: 'hermès', celine: 'celine', polene: 'polène', courreges: 'courrèges', loropiana: 'loro piana', margiela: 'maison margiela', mihara: 'mihara' };
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('form[role="search"]')) return;
    var i = f.querySelector('input[name="q"]'); if (!i) return;
    var k = (i.value || '').trim().toLowerCase(); if (ALIAS[k]) i.value = ALIAS[k];
  }, true);

  /* ---------- Rails (onglets chargés en arrière-plan) ---------- */
  var cache = {};
  function loadUrls(urls, limit) {
    var key = urls.join(' ');
    if (cache[key]) return Promise.resolve(cache[key]);
    return Promise.all(urls.map(function (u) {
      var sep = u.indexOf('?') >= 0 ? '&' : '?';
      return fetch(u + sep + 'section_id=mf-grid', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (parts) {
      var tmp = document.createElement('div'), seen = {}, out = [];
      parts.forEach(function (h) {
        tmp.innerHTML = h;
        $$('[data-mf-card]', tmp).forEach(function (c) { var k = c.dataset.title; if (!seen[k]) { seen[k] = 1; out.push({ h: c.outerHTML, r: Number(c.dataset.rank) || 500, v: (c.dataset.vendor || '').toLowerCase(), t: (c.dataset.title || '').toLowerCase(), i: out.length }); } });
      });
      if (parts.length > 1) out.sort(function (a, b) { return a.r - b.r || (a.v < b.v ? -1 : a.v > b.v ? 1 : 0) || (a.t < b.t ? -1 : a.t > b.t ? 1 : 0) || a.i - b.i; });
      cache[key] = out.slice(0, limit || 12).map(function (o) { return o.h; }).join('');
      return cache[key];
    });
  }
  function selectTab(tab) {
    var sec = tab.closest('[data-mf-railsec]'); if (!sec) return;
    var rail = $('[data-mf-rail]', sec);
    $$('[data-mf-tab]', sec).forEach(function (b) { var on = b === tab; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', String(on)); });
    if (!rail.dataset.featured && tab.dataset.mfTab !== 'featured' && !$('[data-mf-autoload]', rail)) rail.dataset.featured = rail.innerHTML;
    if (tab.dataset.mfTab === 'featured') { if (rail.dataset.featured) rail.innerHTML = rail.dataset.featured; paintSwatches(rail); rail.scrollLeft = 0; return; }
    var urls = (tab.dataset.urls || '').split(' ').filter(Boolean);
    rail.classList.add('is-loading');
    loadUrls(urls, Number(rail.dataset.limit) || 12).then(function (html) {
      rail.innerHTML = html || '<p class="mf-count">' + (T.empty || '—') + '</p>';
      rail.classList.remove('is-loading'); rail.scrollLeft = 0; paintSwatches(rail);
    });
  }
  function initRails() {
    $$('[data-mf-railsec]').forEach(function (sec) {
      var rail = $('[data-mf-rail]', sec); if (!rail) return;
      if (!$('[data-mf-autoload]', rail)) return;
      var on = $('[data-mf-tab].is-on', sec);
      if (on) { selectTab(on); return; }
      var auto = (rail.dataset.auto || '').trim();
      if (auto) loadUrls([auto], Number(rail.dataset.limit) || 12).then(function (html) { rail.innerHTML = html; paintSwatches(rail); });
    });
  }

  /* ---------- Catalogue : filtre par marque + tri ---------- */
  function applyBrands() {
    var sel = $$('[data-mf-brand][aria-pressed="true"]').map(function (b) { return b.dataset.mfBrand; });
    var n = 0;
    $$('[data-mf-coll] [data-mf-card]').forEach(function (c) { var ok = !sel.length || sel.indexOf(c.dataset.vendor) >= 0; c.hidden = !ok; if (ok) n++; });
    $$('[data-mf-coll] [data-mf-group]').forEach(function (g) { g.hidden = !$('[data-mf-card]:not([hidden])', g); });
    var cnt = $('[data-mf-count]'); if (cnt) cnt.textContent = n;
    var lab = $('[data-mf-filter-label]'), fbtn = $('.mf-fbtn');
    if (lab) lab.textContent = (lab.dataset.base || (lab.dataset.base = lab.textContent)) + (sel.length ? ' · ' + sel.length : '');
    if (fbtn) fbtn.classList.toggle('has-f', sel.length > 0);
  }
  var sortSel = $('[data-mf-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(window.location.href);
    if (sortSel.value) u.searchParams.set('sort_by', sortSel.value); else u.searchParams.delete('sort_by');
    window.location.href = u.toString();
  });

  /* ---------- Fiche produit ---------- */
  function initProduct() {
    var root = $('[data-mf-product]'); if (!root) return;
    var pj = $('[data-mf-product-json]', root); if (!pj) return;
    var P = JSON.parse(pj.textContent);
    var form = $('#mf-pform', root), input = $('[data-mf-variant-input]', root), warn = $('[data-mf-warn]', root);
    var fields = $$('[data-mf-option]', root);
    var params = new URLSearchParams(window.location.search);
    var start = null;
    P.variants.forEach(function (v) { if (String(v.id) === params.get('variant')) start = v; });
    var sel = fields.map(function (f, i) {
      var isColor = f.dataset.color === 'true';
      if (start) return start.options[i];
      if (isColor) { var on = $('.is-on', f); return on ? on.dataset.mfVal : (P.variants[0] && P.variants[0].options[i]); }
      return f.querySelectorAll('[data-mf-val]').length === 1 ? f.querySelector('[data-mf-val]').dataset.mfVal : null;
    });
    function find() { return P.variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); })[0]; }
    var mainImg = $('#mf-main-img', root);
    function showImg(src) { if (!mainImg || !src) return; mainImg.removeAttribute('srcset'); mainImg.src = src; mainImg.classList.remove('mf-swapA'); void mainImg.offsetWidth; mainImg.classList.add('mf-swapA'); }
    function render() {
      fields.forEach(function (f, i) {
        var isColor = f.dataset.color === 'true';
        $$('[data-mf-val]', f).forEach(function (b) {
          var on = b.dataset.mfVal === sel[i];
          b.setAttribute('aria-pressed', String(on)); b.classList.toggle('is-on', on);
          if (!isColor) {
            var exists = P.variants.some(function (v) { return v.options[i] === b.dataset.mfVal && v.options.every(function (o, j) { return j === i || !sel[j] || fields[j].dataset.color !== 'true' || sel[j] === o; }); });
            b.classList.toggle('is-off', !exists);
          }
        });
        var lab = $('[data-mf-opt-label]', f); if (lab) lab.textContent = sel[i] || lab.dataset.empty || lab.textContent;
      });
      var v = find();
      if (v) {
        input.value = v.id;
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
        var pr = $('[data-mf-price]', root); if (pr && window.Shopify && Shopify.formatMoney) pr.textContent = Shopify.formatMoney(v.price);
      }
      var add = $('[data-mf-add]', root);
      if (add) { add.disabled = !!(v && !v.available); if (v && !v.available) add.textContent = T.soldOut; }
    }
    fields.forEach(function (f, i) {
      var lab = $('[data-mf-opt-label]', f); if (lab && !lab.dataset.empty) lab.dataset.empty = lab.textContent;
      $$('[data-mf-val]', f).forEach(function (b) {
        b.addEventListener('click', function () {
          sel[i] = b.dataset.mfVal; if (warn) warn.hidden = true;
          if (f.dataset.color === 'true') {
            var v = P.variants.filter(function (x) { return x.options[i] === sel[i] && (x.featured_media || x.featured_image); })[0];
            var src = v && ((v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) || (v.featured_image && v.featured_image.src));
            var thumbs = $$('[data-mf-thumb]', root), hit = null;
            if (src) { hit = thumbs.filter(function (t) { return v.featured_media && String(v.featured_media.id) === t.dataset.media; })[0]; showImg(src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=1200'); }
            else if (thumbs.length) {
              // no photo linked to this colour in Shopify: match the photo's alt text, else the photo in the same position as the colour
              var key = sel[i].toLowerCase(), vals = $$('[data-mf-val]', f).map(function (x) { return x.dataset.mfVal; });
              hit = thumbs.filter(function (t) { var a = (t.dataset.alt || '').toLowerCase(); return a && a.indexOf(key) >= 0; })[0];
              if (!hit && thumbs.length >= vals.length) hit = thumbs[vals.indexOf(sel[i])];
              if (hit) showImg(hit.dataset.src);
            }
            thumbs.forEach(function (t) { t.classList.toggle('is-on', t === hit); });
          }
          render();
        });
      });
    });
    $$('[data-mf-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { showImg(t.dataset.src); $$('[data-mf-thumb]', root).forEach(function (x) { x.classList.toggle('is-on', x === t); }); });
    });
    function ready() {
      var missing = fields.filter(function (f, i) { return !sel[i]; });
      if (missing.length) {
        var name = $('legend span', missing[0]); name = name ? name.textContent.replace(':', '').trim().toLowerCase() : '';
        if (warn) { warn.textContent = (T.chooseFirst || 'Choisis OPTION pour continuer.').replace('OPTION', 'ta ' + name); warn.hidden = false; }
        missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        return null;
      }
      var v = find(); if (!v) { if (warn) { warn.textContent = T.soldOut; warn.hidden = false; } return null; }
      return v;
    }
    function go(buyNow) {
      var v = ready(); if (!v) return;
      var btn = $(buyNow ? '[data-mf-buynow]' : '[data-mf-add]', root); if (btn) btn.disabled = true;
      var item = { id: v.id, quantity: 1 };
      var eng = $('[data-mf-engrave]', root);
      if (eng) {
        var txt = ($('[data-mf-eng-text]', eng) || {}).value || '';
        txt = txt.trim().toUpperCase();
        if (txt) {
          var fixed = $('[data-mf-eng-fixed]', eng), on = $('[data-mf-eng-col].is-on', eng);
          item.properties = { 'Gravure (initiales)': txt, 'Couleur de gravure': fixed ? fixed.dataset.mfEngFixed : (on ? on.dataset.mfEngCol : 'Argentée') };
        }
      }
      addToCart([item]).then(function () {
        if (buyNow) { window.location.href = '/checkout'; return; }
        toast(T.added); return refreshCart(true);
      }).catch(function (err) { toast(err.message || T.error); }).finally(function () { if (btn) btn.disabled = false; });
    }
    $$('[data-mf-eng-col]', root).forEach(function (b) {
      b.addEventListener('click', function () { $$('[data-mf-eng-col]', root).forEach(function (x) { var o = x === b; x.classList.toggle('is-on', o); x.setAttribute('aria-pressed', String(o)); }); });
    });
    var et = $('[data-mf-eng-text]', root);
    if (et) et.addEventListener('input', function () { var p = et.selectionStart; et.value = et.value.toUpperCase().replace(/[^A-Z.\s&]/g, ''); try { et.setSelectionRange(p, p); } catch (e) {} });
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); go(false); });
    var bn = $('[data-mf-buynow]', root); if (bn) bn.addEventListener('click', function () { go(true); });
    render();
  }

  /* ---------- Recommandations ---------- */
  function initReco() {
    var el = $('[data-mf-reco]'); if (!el || !el.dataset.url) return;
    fetch(el.dataset.url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
      var tmp = document.createElement('div'); tmp.innerHTML = h;
      var n = $('[data-mf-reco]', tmp); if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; paintSwatches(el); }
    }).catch(function () {});
  }

  /* ---------- Coucher de soleil : parallaxe ---------- */
  function initHero() {
    $$('[data-mf-hero]').forEach(function (h) {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var raf = null, x = 0, y = 0;
      h.addEventListener('mousemove', function (e) {
        x = e.clientX; y = e.clientY; if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null; var r = h.getBoundingClientRect();
          h.style.setProperty('--mx', (((x - r.left) / r.width) * 2 - 1).toFixed(3));
          h.style.setProperty('--my', (((y - r.top) / r.height) * 2 - 1).toFixed(3));
        });
      });
      h.addEventListener('mouseleave', function () { h.style.setProperty('--mx', '0'); h.style.setProperty('--my', '0'); });
    });
  }


  /* ---------- Suivre ma commande ---------- */
  function trackCarrier(code) {
    var c = code.replace(/[\s-]/g, '').toUpperCase();
    if (/^\d{10}$/.test(c) || /^JJD\d+/.test(c) || /^JVGL/.test(c) || /^(GM|LX|RX)\d{16,}/.test(c)) return 'dhl';
    return 'laposte';
  }
  function trackUrl(carrier, code) {
    var c = encodeURIComponent(code.replace(/[\s-]/g, '').toUpperCase());
    if (carrier === 'dhl') return 'https://www.dhl.com/fr-fr/home/tracking.html?tracking-id=' + c + '&submit=1';
    return 'https://www.laposte.fr/outils/suivre-vos-envois?code=' + c;
  }
  function initTrack() {
    $$('[data-mf-track]').forEach(function (f) {
      if (f.dataset.mfReady) return; f.dataset.mfReady = '1';
      var input = $('input[name="code"]', f), msg = $('[data-mf-track-msg]', f), touched = false;
      $$('input[name="carrier"]', f).forEach(function (r) { r.addEventListener('change', function () { touched = true; }); });
      input.addEventListener('input', function () {
        if (msg) msg.hidden = true;
        if (touched) return;
        var want = trackCarrier(input.value), r = $('input[name="carrier"][value="' + want + '"]', f); if (r) r.checked = true;
      });
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = input.value.replace(/[\s-]/g, '');
        var say = function (t) { if (msg) { msg.textContent = t; msg.hidden = false; } };
        if (!code) { say(T.trackEmpty || 'Entre ton numéro de suivi.'); input.focus(); return; }
        if (code.length < 8) { say(T.trackBad || 'Ce numéro semble incomplet.'); input.focus(); return; }
        var r = $('input[name="carrier"]:checked', f), carrier = r ? r.value : trackCarrier(code);
        say(T.trackOpen || 'Ouverture du suivi…');
        var w = window.open(trackUrl(carrier, code), '_blank', 'noopener');
        if (!w) window.location.href = trackUrl(carrier, code);
      });
    });
  }
  function openTrack() {
    var m = $('[data-mf-track-modal]'); if (!m) return;
    var mm = $('[data-mf-menu]'); if (mm) mm.hidden = true;
    m.hidden = false; document.documentElement.style.overflow = 'hidden';
    var i = $('input[name="code"]', m); if (i) setTimeout(function () { i.focus(); }, 60);
  }
  function closeTrack() { var m = $('[data-mf-track-modal]'); if (m && !m.hidden) { m.hidden = true; document.documentElement.style.overflow = ''; } }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    if (t.closest('[data-mf-track-open]')) { e.preventDefault(); openTrack(); return; }
    if (t.closest('[data-mf-track-close]')) { closeTrack(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTrack(); });

  function init() {
    paintSwatches(document);
    initHero(); initRails(); initProduct(); initReco(); initTrack();
    if (window.location.hash === '#suivi-commande') openTrack();
    if (window.location.hash === '#mf-cart') refreshCart(true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { paintSwatches(e.target); initRails(); initHero(); initTrack(); });
})();
